import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = { class: "pb-3 text-left" }
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal hunde'
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: "dogType1",
  class: "pb-3"
}
const _hoisted_7 = {
  key: "gender1",
  class: "pb-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvilket køn er din hund?'
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg køn'
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: "dogType2",
  class: "pb-3"
}
const _hoisted_13 = {
  key: "gender2",
  class: "pb-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvilket køn er din hund?'
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "text-left"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg køn'
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SegmentedControlComponent, {
        key: "dummy",
        id: "dogCount",
        onSegmentedComponent: _ctx.dogCount,
        options: _ctx.model.calculation.abCalc.dogCountOptions,
        labels: _ctx.model.calculation.abCalc.dogCountLabels,
        preSelected: _ctx.model.dogInfo.dogCount + '',
        controlsPerRow: 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.cms.dogCountlabel), 1)
          ])
        ]),
        _: 1
      }, 8, ["onSegmentedComponent", "options", "labels", "preSelected"]),
      (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.validDogCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.validDogCount)
          ? (_openBlock(), _createBlock(_component_inputFieldComponent, {
              class: "text-left pb-3",
              key: "dogName1",
              id: "dogName1",
              name: "dogName1",
              placeholder: "F.eks. Fido",
              label: "Navn på hund",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              innerData: _ctx.model.dogInfo,
              readonlyValue: _ctx.readonlyDogName1,
              required: true,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name)
            }, null, 8, ["validateOnLoad", "innerData", "readonlyValue", "visibleError"]))
          : _createCommentVNode("", true),
        (_ctx.validDogCount && _ctx.model.dogInfo.dogName1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                defaultValue: _ctx.model.dogInfo.dogType1,
                autocompleteId: "dog1",
                label: "Hvilken race tilhøre din hund?",
                placeholder: "Indtast f.eks Beagle...",
                searchByCleanedInput: true,
                resultList: _ctx.cms.dogList,
                isValid: _ctx.model.dogInfo.dogType1 !== undefined,
                visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                errorMessage: "Vælg en hunde race",
                onSearch: _ctx.dogTypeSelected
              }, null, 8, ["defaultValue", "resultList", "isValid", "visibleError", "onSearch"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.validDogCount && _ctx.model.dogInfo.dogName1 && _ctx.model.dogInfo.dogTypeId1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_SegmentedControlComponent, {
                id: "gender1",
                onSegmentedComponent: _ctx.handleGender,
                options: _ctx.genderOptions,
                labels: _ctx.genderLabels,
                preSelected: _ctx.model.dogInfo.gender1,
                controlsPerRow: 4
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onSegmentedComponent", "options", "labels", "preSelected"]),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.dogInfo.gender1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.validDogCount && _ctx.model.dogInfo.dogName1 && _ctx.model.dogInfo.dogTypeId1 && _ctx.model.dogInfo.gender1)
          ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
              key: "birthdate1",
              class: "text-left mb-3",
              label: "Fødselsdag (dd-mm-åååå)",
              innerId: "birthdate1",
              innerData: _ctx.model.dogInfo,
              placeholder: "F.eks. 21-12-2020",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              validationRule: "BeforeToday",
              dateLimitIncluded: false,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              maxLowerLimitYears: 25
            }, null, 8, ["innerData", "validateOnLoad", "visibleError"]))
          : _createCommentVNode("", true),
        (_ctx.showSecondDog)
          ? (_openBlock(), _createBlock(_component_inputFieldComponent, {
              class: "text-left pb-3",
              key: "dogName2",
              id: "dogName2",
              name: "dogName2",
              placeholder: "F.eks. King",
              label: "Navn på anden hund",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              readonlyValue: _ctx.readonlyDogName2,
              innerData: _ctx.model.dogInfo,
              required: true,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name)
            }, null, 8, ["validateOnLoad", "readonlyValue", "innerData", "visibleError"]))
          : _createCommentVNode("", true),
        (_ctx.showSecondDog && _ctx.model.dogInfo.dogName2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_SearchComponent, {
                defaultValue: _ctx.model.dogInfo.dogType2,
                autocompleteId: "dog2",
                label: "Hvilken race tilhøre din anden hund?",
                placeholder: "Indtast f.eks Beagle...",
                searchByCleanedInput: true,
                resultList: _ctx.cms.dogList,
                isValid: _ctx.model.dogInfo.dogType2 !== undefined,
                visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                errorMessage: "Vælg en hunde race",
                onSearch: _ctx.dogTypeSelected
              }, null, 8, ["defaultValue", "resultList", "isValid", "visibleError", "onSearch"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showSecondDog && _ctx.model.dogInfo.dogName2 && _ctx.model.dogInfo.dogTypeId2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_SegmentedControlComponent, {
                id: "gender2",
                onSegmentedComponent: _ctx.handleGender,
                options: _ctx.genderOptions,
                labels: _ctx.genderLabels,
                preSelected: _ctx.model.dogInfo.gender2,
                controlsPerRow: 4
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onSegmentedComponent", "options", "labels", "preSelected"]),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.dogInfo.gender2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showSecondDog && _ctx.model.dogInfo.dogName2 && _ctx.model.dogInfo.dogTypeId2 && _ctx.model.dogInfo.gender2)
          ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
              key: "birthdate2",
              class: "text-left mb-3",
              label: "Fødselsdag (dd-mm-åååå)",
              innerId: "birthdate2",
              innerData: _ctx.model.dogInfo,
              placeholder: "F.eks. 21-12-2020",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              validationRule: "BeforeToday",
              dateLimitIncluded: false,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              maxLowerLimitYears: 25
            }, null, 8, ["innerData", "validateOnLoad", "visibleError"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        textContent: _toDisplayString(_ctx.card.linkText),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}